import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map, catchError, tap, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ShopTranslationsService } from './shop-translations.service';
import { ConnectionService } from '../../../services/connection/connection.service';
import { LoggerService } from '../../../services/logger/logger.service';
import { LocalizationService } from '../../../services/localization.service';

@Injectable({
  providedIn: 'root'
})
export class ShopTranslationsOdooService extends ShopTranslationsService {

  constructor(
    private connectionService: ConnectionService,
    private translateService: TranslateService,
    private loggerService: LoggerService,
    private localizationService: LocalizationService,
  ) {
    super();
  }

  initialize(): Observable<boolean> {
    return this.connectionService.sendJsonPostRequest('/store/translations')
      .pipe(
        switchMap(translations => this._reload(translations)),
        catchError(err => {
          this.loggerService.error(`ShopTranslationsOdooService. initialize. error: ${err ? err.message || err : err}`);
          return of(false);
        })
      );
  }

  private _reload(translations: any): Observable<boolean> {
    return of(translations).pipe(
      switchMap((_translations => {
        if (!_translations) {
          return of(false);
        }

        const translationUpdateObservables = Object.entries(_translations).map(
          ([lang, values]) => {
            return this.translateService.use(lang)
              .pipe(
                tap(() => { this.translateService.setTranslation(lang, values, true); })
              );
          });

        return forkJoin(translationUpdateObservables).pipe(
          switchMap(() => {
            const availableLangs = this.localizationService.availableLangs;
            if (availableLangs?.length > 0) {
              return this.translateService.use(availableLangs[0]).pipe(
                map(() => {
                  this.localizationService.initialize();
                  return true;
                })
              );
            }
            return of(true);
          }),
        );
      }))
    );
  }

}
